module.exports = __webpack_public_path__ + "img/icons BFr_24.cb089461.png";